import React from "react"
import { Website } from "sharedTypes"
import Classic from "./site_covers/Classic"
import Modern from "./site_covers/Modern"
import Pictorial from "./site_covers/Pictorial"

const SiteCover = ({
  buttonClick,
  website: {
    actionText,
    coverImageUrl,
    dateHeader,
    dateLine1,
    dateLine2,
    locationLine1,
    locationLine2,
    locationLine3,
    locationVenue,
    rsvpButtonColor,
    templateId,
    title,
  },
}: {
  buttonClick: (() => void) | null
  website: Website
}) => {
  const siteCoverProps = {
    buttonClick,
    actionText,
    coverImageUrl,
    dateHeader,
    dateLine1,
    dateLine2,
    locationLine1,
    locationLine2,
    locationLine3,
    locationVenue,
    rsvpButtonColor,
    title,
  }

  switch (templateId) {
    case 2:
      return <Pictorial {...siteCoverProps} />
    case 3:
      return <Modern {...siteCoverProps} />
    default:
      return <Classic {...siteCoverProps} />
  }
}

export default SiteCover
